import React from "react";

export default function SpotCarLogo({ size = 32, className = "" }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            aria-hidden="true"
            focusable="false"
        >
            <rect x="1.25" y="1.25" width="29.5" height="29.5" rx="9" ry="9" stroke="currentColor" strokeWidth="2.5" fill="none" />
            <path
                d="M16 7.5Q19.1 7.5 21.2 8.7Q23.2 10 23.3 12.5L23.3 12.8L18.3 12.8L18.3 12.7Q18.3 12 17.8 11.5Q17.2 11.1 16.2 11.1Q15.1 11.1 14.5 11.4Q14 11.7 14 12.1Q14 12.8 14.7 13.1Q15.5 13.4 17.2 13.7Q19.2 14.2 20.5 14.6Q21.8 15 22.7 16Q23.7 17.1 23.7 18.8Q23.7 21.7 21.7 23.1Q19.8 24.5 16.4 24.5Q12.6 24.5 10.4 23.2Q8.3 22 8.3 18.7L13.3 18.7Q13.3 19.9 13.9 20.3Q14.6 20.8 16 20.8Q17 20.8 17.6 20.5Q18.3 20.3 18.3 19.6Q18.3 19 17.6 18.7Q16.8 18.4 15.2 18.1Q13.2 17.7 11.8 17.2Q10.5 16.7 9.5 15.7Q8.5 14.6 8.5 12.7Q8.5 10 10.6 8.7Q12.7 7.5 16 7.5Z"
                fill="currentColor"
            />
        </svg>
    );
}
